import { Button } from "antd";
import classNames from "classnames";
import HBModel from ".";
import styles from "./info.module.less";
import ModalWrap from "./ModalWrap";
// import HBIcon from "../HBIcon";

/**
 * 信息提示弹窗
 * @param {{
 *  title?: import("react").ReactNode
 *  content?: import("react").ReactNode
 *  onOk?: ()=>any
 *  okText?: string,
 *  okButtonProps?: import("antd").ButtonProps
 *  cancelText?: string,
 *  cancelButtonProps?: import("antd").ButtonProps
 *  onCancel?: ()=>any,
 *  onCancelBtnClick?: ()=>any
 *  hideOkBtn?: boolean,
 *  hideCancelBtn?: boolean,
 *  width?: number
 *  withHeadline?: boolean
 * } & import(".").HBModalProps} props
 * @returns
 */
function RawHBInfo({
  content,
  title = "提示",
  onOk,
  okText,
  okButtonProps,
  cancelText,
  cancelButtonProps,
  onCancel,
  onCancelBtnClick,
  hideOkBtn = false,
  hideCancelBtn = false,
  width = 400,
  withHeadline = false,
  ...props
}) {
  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      width={width}
      onCancel={onCancel}
    >
      <div
        className={classNames([
          styles.title,
          withHeadline && styles.withHeadline,
        ])}
      >
        {title}
      </div>
      <div className={styles.content}>{content}</div>
      <div className={styles.footer}>
        {!hideCancelBtn && (
          <Button
            width="40"
            onClick={() => {
              onCancel && onCancel();
              onCancelBtnClick && onCancelBtnClick();
            }}
            style={{ marginRight: "8px" }}
            {...(cancelButtonProps || {})}
          >
            {cancelText || "取消"}
          </Button>
        )}
        {!hideOkBtn && (
          <Button
            width="40"
            type={"primary"}
            onClick={() => {
              onOk && onOk();
            }}
            {...(okButtonProps || {})}
          >
            {okText || "确认"}
          </Button>
        )}
      </div>
    </HBModel>
  );
}

const HBInfoDialog = ModalWrap(RawHBInfo);
export default HBInfoDialog;
